import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { PricingAndTicketingNdcCommercialFaqPage } from 'src/app/model/page/group/faq/pricing-and-ticketing-ndc-commercial-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-pricing-and-ticketing-ndc-commercial-faq-page',
  templateUrl: './pricing-and-ticketing-ndc-commercial-faq-page.component.html',
  styleUrls: ['./pricing-and-ticketing-ndc-commercial-faq-page.component.scss']
})
export class PricingAndTicketingNdcCommercialFaqPageComponent implements OnInit {
  param: number = -1;
  pricingAndTicketingPage: PricingAndTicketingNdcCommercialFaqPage = {} as PricingAndTicketingNdcCommercialFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-commercial-pricing') {
        this.pricingAndTicketingPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));

    this.pricingAndTicketingPage.sections = [];

    const query = { 'fields.title': 'NDC Commercial FAQ#Pricing and Ticketing' };
    this.contentfulService.getPageContentWithEntries(query).then((PricingAndTicketingNdcCommercialFaqPageEntries) => {
      this.mapBanner(PricingAndTicketingNdcCommercialFaqPageEntries);
      this.mapSections(PricingAndTicketingNdcCommercialFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.pricingAndTicketingPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(pricingAndTicketingPageEntries: Entry<any>[]) {
    pricingAndTicketingPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.pricingAndTicketingPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(pricingAndTicketingPageEntries: Entry<any>[]) {
    pricingAndTicketingPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.pricingAndTicketingPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log(entry);
    let title = entry.fields['title'] as string;
    let pageTitle = title.split('#')[2];
    this.pricingAndTicketingPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
